import React, { Component } from 'react';
import '../static/css/bootstrap.min.css'
import '../index.css'
import musio_info from '../resources/p3_img1.png'


class Section3 extends Component {
  render() {
    return (
      <section id="page_3">
        <div className="container">
          <div className="row">
            <div className="col-xs-12 text-center title">
              そんなあなたを<br />
              Musioがサポートします。
            </div>

            <div className="col-xs-12 text-center content">
              <span className="red_font">新しい観点から英語教育を変えるAIロボット。</span><br />
              生徒のモチベーション、授業コンテンツ、生徒管理、アダプティブラーニングの<br />
              要素で、「話す」スキル向上にむけて全面的にサポートします。
            </div>

            <div className="col-sm-offset-2 col-sm-8 col-xs-12 musio_info">
              <img className="img-responsive" src={musio_info} alt='musio_info'/>
            </div>
            <a href="https://themusio.com/home">
              <div className=" text-center">
                <div className="musio_button text-center">
                  Musioについてさらに詳しく→
                </div>
              </div>
            </a>
          </div>
        </div>
      </section>
    );
  }
}

export default Section3;



// WEBPACK FOOTER //
// ./src/sections/Section3.js